export interface StepFooterProps {
  dirty?: boolean;
  saving?: boolean;
  /** A form step's Save; a step that writes as it goes (Guests) has none. */
  onSave?: () => void;
  /** Where the next step goes, once this one is saved. */
  onNext?: () => void;
  nextLabel?: string;
}

/** Save for a form step, and on to the next one. */
export function StepFooter({
  dirty = false,
  saving = false,
  onSave,
  onNext,
  nextLabel,
}: StepFooterProps) {
  return (
    <div className="sticky bottom-0 -mx-1 mt-6 flex flex-wrap items-center justify-end gap-2 border-t border-gray-100 bg-white/95 px-1 py-3 backdrop-blur">
      {dirty && <span className="mr-auto text-xs text-amber-700">Unsaved changes</span>}
      {onSave && (
        <button
          type="button"
          onClick={onSave}
          disabled={!dirty || saving}
          className="min-h-11 sm:min-h-0 px-4 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
        >
          {saving ? 'Saving…' : 'Save'}
        </button>
      )}
      {onNext && (
        <button
          type="button"
          onClick={onNext}
          disabled={saving}
          className="min-h-11 sm:min-h-0 px-4 py-2 text-sm text-white bg-primary-600 rounded-lg hover:bg-primary-700 disabled:opacity-50"
        >
          {nextLabel ?? 'Next'}
        </button>
      )}
    </div>
  );
}
